import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { API_TAGS } from "../../helpers/constants";
import { RootState } from "../store";

// const baseUrl = process.env.REACT_APP_SERVER_ENDPOINT + "/api/";
const baseUrl = `https://test.appaidentis.kz/api/`;

export const panoramicApi = createApi({
  reducerPath: "panoramicApi",
  tagTypes: [API_TAGS.PANORAMIC],
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).userSlice.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    postCasesPanoramic: builder.mutation<string, string>({
      query: (panoramicImageId) => ({
        url: `/cases/panoramic/${panoramicImageId}`,
        method: "GET",
        responseHandler: async (response) => {
          const blob = await response.blob();
          return URL.createObjectURL(blob);
        },
      }),
    }),
    // Add endpoint for saving tooth comments
    postTeethComment: builder.mutation<
      any,
      {
        panoramicImageId: string | number;
        toothId: string | number;
        data: string;
      }
    >({
      query: ({ panoramicImageId, toothId, data }) => ({
        url: `/cases/panoramic-image/${panoramicImageId}/teeth/${toothId}/comment`,
        method: "POST",
        body: data,
      }),
    }),
    // Add endpoint for changing tooth number
    changeToothNumber: builder.mutation<
      any,
      {
        panoramicImageId: string | number;
        oldToothIndex: string;
        newToothIndex: string;
      }
    >({
      query: ({ panoramicImageId, oldToothIndex, newToothIndex }) => ({
        url: `/cases/panoramic-image/${panoramicImageId}/teeth/change-number`,
        method: "POST",
        body: {
          oldToothIndex,
          newToothIndex,
        },
      }),
      invalidatesTags: [API_TAGS.PANORAMIC],
    }),
  }),
});

export const {
  usePostCasesPanoramicMutation,
  usePostTeethCommentMutation,
  useChangeToothNumberMutation,
} = panoramicApi;
